import React, { useEffect } from "react";

const addTableRow = () => {
	const tableRow = document.createElement("tr");
	const cellContents = [
		"Spending Requirement",
		"Start here",
		"Spend $1,000",
		"Spend $2,000",
		"Spend $5,000"
	];

	const cellClass = "lion-tier-benefits-compare__row-cell";

	const tryInsert = () => {
		const tableBody = document.querySelector(".lion-tier-benefits-compare table tbody");
		if (tableBody) {
			clearInterval(intervalId);
			for (const cellContent of cellContents) {
				const cell = document.createElement("td");
				cell.textContent = cellContent;
				cell.classList.add(cellClass);
				tableRow.appendChild(cell);
			}
			tableRow.classList.add("lion-tier-benefits-compare__row");
			tableBody.insertBefore(tableRow, tableBody.firstChild);
		}
	};

	const intervalId = setInterval(tryInsert, 1000);

};

const TierBenefits = ({ data }) => {
	useEffect(() => {
		window.loyaltylion?.ui?.refresh();

		addTableRow();
	}, []);

	return (
		<div className="md:py-8">
			<h2 className="text-center pb-10">{data.title || "Tiers"}</h2>
			<div data-lion-tier-benefits-compare></div>
		</div>
	);
};

export default TierBenefits;